import appConfig from "../config/app-config";

export type Province = {
	id: number;
	name: string;
	initials: string;
};

const { address: GEOLOCATION_API_URL, key: GEOLOCATION_API_KEY } = appConfig.apis.geolocationApiEnv;

const useProvinces = () => {
	const fetchProvinces = async () => {
		const storageKey = 'provinces';

		const cachedProvinces = localStorage.getItem(storageKey);
		if (cachedProvinces) {
			return JSON.parse(cachedProvinces) as Province[];
		}

		const response = await fetch(
			`${GEOLOCATION_API_URL}/provinces`,
			{
				headers: {
					"x-api-key": GEOLOCATION_API_KEY,
				},
			},
		);

		if (!response.ok) throw new Error('Erro ao buscar estados');

		const data = await response.json();

		const formattedProvinces = data.map((province: any) => ({
			id: province.id,
			name: province.name,
			initials: province.initials,
		}));

		localStorage.setItem(storageKey, JSON.stringify(formattedProvinces));
		return formattedProvinces;
	};

	return { fetchProvinces };
};

export default useProvinces;